import { GetQuestionBlock } from "@/pages/quiz/context/types";
import { CustomFormBlock } from "@/types";

interface IProps {
  questions: CustomFormBlock[] | null;
  isPrerenderEnabled: boolean;
  selectedQuestionIdx: number;
  getQuestionBlock: GetQuestionBlock;
}

// Renders component and hides it from user so assets for question
// can start loading while the previous question is displayed
const QuestionPrerenderContainer = ({
  questions,
  isPrerenderEnabled,
  selectedQuestionIdx,
  getQuestionBlock,
}: IProps) => {
  if (isPrerenderEnabled && questions) {
    const questionsToPrerender = questions
      .map((question) => ({
        ...getQuestionBlock(question),
        question,
      }))
      .filter((q) => !!q.config?.prerenderMode);

    return (
      <div className="hidden absolute -top-[2000px]">
        {questionsToPrerender.map(({ question, Component }) => (
          <Component
            key={question.id}
            question={question}
            disableAnimation
            onBack={() => {}}
            questionValue={{}}
            setQuestionAnswer={async () => ({})}
            setQuestionValue={() => {}}
          />
        ))}
      </div>
    );
  }

  const nextQuestionIndex =
    selectedQuestionIdx >= 0 &&
    selectedQuestionIdx < (questions?.length ?? 0) - 1
      ? selectedQuestionIdx + 1
      : -1;

  const questionToPrerender =
    nextQuestionIndex !== -1 && questions ? questions[nextQuestionIndex] : null;

  if (questionToPrerender) {
    const questionBlock = getQuestionBlock(questionToPrerender);
    const { Component, question, config } = {
      ...questionBlock,
      question: questionToPrerender,
    };

    if (config?.prerenderMode) {
      return (
        <div className="hidden absolute -top-[2000px]">
          <Component
            question={question}
            disableAnimation
            onBack={() => {}}
            questionValue={{}}
            setQuestionAnswer={async () => ({})}
            setQuestionValue={() => {}}
          />
        </div>
      );
    }
  }

  return null;
};

export { QuestionPrerenderContainer };
